import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { withStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import { selectIsAuthenticated } from '../../store/selectors';

import styles from './styles';
import JHLogoIcon from '../JHLogoIcon';
import NavMenu from '../NavMenu';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    topBar: PropTypes.string,
    logo: PropTypes.string,
    verticalSep: PropTypes.string,
    grow: PropTypes.string,
    topRightButton: PropTypes.string,
    topIcons: PropTypes.string,
  }).isRequired,
  width: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool,
};
const defaultProps = {};

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

// class Header extends React.Component {
const Header = ({ classes, width, loggedIn }) => {
  const [open, setOpen] = useState(false);

  if (width !== 'xs')
    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar className={classes.topBar}>
            <IconButton className={classes.logo}>
              <a href="/">
                {/* <img
                  src="https://images.ctfassets.net/rg5y8r6t6cjr/1dCThZI6QEdbQKkOBCqA19/adcce125b8a11a0cb382d69f80f7d694/JamesHardie-bug-logo-w-space-RGB.svg"
                  alt="JHLogoIcon"
                /> */}
                <JHLogoIcon />
              </a>
            </IconButton>
            <div className={classes.verticalSep} />
            <Typography
              variant="h6"
              color="inherit"
              className={classes.appTitle}
            >
              myHardies
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
    );
  return (
    <div className={classes.root}>
      {loggedIn && (
        <SwipeableDrawer
          disableBackdropTransition={!iOS}
          disableDiscovery={iOS}
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          classes={{ paper: classes.drawerPaper }}
        >
          <NavMenu
            className={classes.drawer}
            handleClose={() => setOpen(false)}
          />
        </SwipeableDrawer>
      )}
      <AppBar position="static">
        <Toolbar
          className={loggedIn ? classes.topBar : classes.topBar_loggedOut}
        >
          {loggedIn && (
            <>
              <IconButton
                className={classes.hamburger}
                onClick={() => setOpen(!open)}
              >
                <MenuIcon />
              </IconButton>
              <div className={classes.verticalSep} />
            </>
          )}
          <JHLogoIcon />
        </Toolbar>
      </AppBar>
    </div>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

const mapStateToProps = createStructuredSelector({
  loggedIn: selectIsAuthenticated(),
});

export default withStyles(styles)(
  withWidth()(connect(mapStateToProps)(Header)),
);
